export let baseUrl =
  process.env.NODE_ENV == "development" ? "https://api.telllead.com" : "https://api.telllead.com"
